import { fromJS } from 'immutable'

import { BANNERS } from '../micrositeAndElsewhereTopBannerConstants'

export const google = () => {
  return fromJS({
    micrositeAndElsewhereTopBanner: {
      banners: [BANNERS.RACE],
    },
  })
}
